import { MdOndemandVideo } from "react-icons/md";
import { defineType } from "sanity";
import { isPresent } from "../../utils/checks";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Hero Video",
  name: "openingHeroVideo",
  type: "object",
  icon: MdOndemandVideo,
  preview: {
    select: {
      title: "title",
      media: "video.posterImage"
    },
    prepare({ title, media }) {
      return {
        title: multilingualStringPreview(title),
        media
      };
    }
  },
  fields: [
    {
      name: "video",
      title: "Video",
      type: "videoWithPosterImage"
    },
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "ctaButtonsMobileOverride",
      title: "Override CTA Buttons on Mobile",
      description:
        "Use different CTA buttons on mobile devices (overrides the desktop CTA buttons)",
      type: "boolean"
    },
    {
      type: "ctaButtons",
      name: "ctaButtonsMobile",
      title: "CTA Buttons Mobile",
      options: {
        collapsible: true,
        collapsed: true
      },
      hidden: ({ parent }) => !parent?.ctaButtonsMobileOverride,
      validation: (Rule) =>
        Rule.custom((value: [], context) => {
          if ((context.parent as any)?.ctaButtonsMobileOverride) {
            if (!isPresent(value) || value.length === 0) {
              return "You must add at least one CTA button when override is enabled.";
            }
          }
          return true;
        })
    }
  ]
});
